// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════
   VNInvestCharts — ChartSplitter default styles
   ────────────────────────────────────────────────────────────────
   Minimalist: invisible until hover, then bright accent line.
   Override colours via --rsc-* CSS custom properties.
════════════════════════════════════════════════════════════════ */

.rsc-splitter {
  position: absolute;
  left: 0;
  right: 0;
  height: 24px;
  margin-top: -12px;
  cursor: row-resize;
  z-index: 12;
  pointer-events: auto;
  user-select: none;
  touch-action: none;
}

.rsc-splitter::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: transparent;
  transition: background 0.15s;
}

.rsc-splitter:hover::after,
.rsc-splitter--dragging::after {
  background: var(--rsc-accent, #2962ff);
}

@media (pointer: coarse) {
  .rsc-splitter {
    height: 28px;
    margin-top: -14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/lib/styles/chart-splitter.css"],"names":[],"mappings":"AAAA;;;;;kEAKkE;;AAElE;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["/* ════════════════════════════════════════════════════════════════\r\n   VNInvestCharts — ChartSplitter default styles\r\n   ────────────────────────────────────────────────────────────────\r\n   Minimalist: invisible until hover, then bright accent line.\r\n   Override colours via --rsc-* CSS custom properties.\r\n════════════════════════════════════════════════════════════════ */\r\n\r\n.rsc-splitter {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 24px;\r\n  margin-top: -12px;\r\n  cursor: row-resize;\r\n  z-index: 12;\r\n  pointer-events: auto;\r\n  user-select: none;\r\n  touch-action: none;\r\n}\r\n\r\n.rsc-splitter::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  height: 2px;\r\n  background: transparent;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.rsc-splitter:hover::after,\r\n.rsc-splitter--dragging::after {\r\n  background: var(--rsc-accent, #2962ff);\r\n}\r\n\r\n@media (pointer: coarse) {\r\n  .rsc-splitter {\r\n    height: 28px;\r\n    margin-top: -14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
